import { render, staticRenderFns } from "./addContent.vue?vue&type=template&id=70582f7b&scoped=true"
import script from "./addContent.vue?vue&type=script&lang=js"
export * from "./addContent.vue?vue&type=script&lang=js"
import style0 from "./addContent.vue?vue&type=style&index=0&id=70582f7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70582f7b",
  null
  
)

export default component.exports